<template>
  <div ref="videoBox" class="viewer">
    <video
      id="myVideo"
      ref="myVideo"
      class="video-js vjs-default-skin vjs-big-play-centered"
      controls
      autoplay
      data-setup="{}"
      crossorigin="anonymous"
      style="width: 100%; height: 100%"
    >
      <source id="source" :src="videoSrc" :type="type" />
    </video>
  </div>
</template>

<script>
export default {
  name: 'vrPlayer',

  props: {
    videoSrc: {
      type: String,
      require: true
    },
    status: {
      type: Number || String,
      require: true
    }
  },

  data() {
    return {}
  },

  computed: {
    type() {
      if (this.videoSrc.indexOf('.mp4') !== -1) {
        //mp4类型
        return 'video/mp4'
      }
      if (this.videoSrc.indexOf('.m3u8') !== -1) {
        //hls类型
        return 'application/x-mpegURL'
      }
      if (this.videoSrc.indexOf('.flv') !== -1) {
        //flv类型
        return 'video/flv'
      }
      //rtmp类型
      return 'rtmp/hls'
    }
  },

  mounted() {
    this.init()
  },

  beforeDestroy() {
    const videoDom = this.$refs.myVideo //不能用document 获取节点
    videojs(videoDom).dispose() //销毁video实例，避免出现节点不存在 但是flash一直在执行,也避免重新进入页面video未重新声明
  },

  methods: {
    init() {
      // videojs 简单使用
      // console.log('videojs’', videojs)
      let oneTime = true
      let myVideo = videojs(
        'myVideo',
        {
          bigPlayButton: true,
          textTrackDisplay: false,
          posterImage: false,
          errorDisplay: false,
          controlBar: {
            // 画中画
            pictureInPictureToggle: false
          }
        },
        function () {
          this.on('timeupdate', function () {
            if ($('.vjs-remaining-time-display').html() != '0:00' && oneTime) {
              document.getElementById('myVideo_html5_api').style.visibility =
                'hidden'
              oneTime = false
            }
          })
        }
      )
      // console.log('myVideo---', myVideo)
      const that = this
      myVideo.ready(function () {
        var video = document.querySelector('.viewer video')
        var videoContainer = document.querySelector('#myVideo')
        var view360Container = document.createElement('div')

        view360Container.className = 'container'
        videoContainer.insertBefore(view360Container, videoContainer.firstChild)

        // console.log('view360Container---', view360Container)
        // console.log('videoContainer---', videoContainer)
        var panoViewer = new eg.view360.PanoViewer(view360Container, {
          video: video,
          projectionType: 'equirectangular',
          isVideo: true,
          useZoom: true,
          entervr: false,
          fov: 75
        })
        // console.log('panoViewer---', panoViewer)
        window.addEventListener('resize', function () {
          // console.log('resize---', panoViewer)
          panoViewer.updateViewportDimensions()
        })

        PanoControls.init(document.querySelector('#myVideo'), panoViewer)
        PanoControls.showLoading()

        //暂停事件监听
        myVideo.on('pause', function () {
          console.log('暂停事件监听')
        })
        //播放事件监听
        myVideo.on('play', function () {
          console.log('播放事件监听')
        })

        // 视频error事件
        myVideo.on('error', function (e) {
          console.log('视频error事件----', e)
          this.error().message =
            '啊哦，播放出错了。<br>请刷新重试，如无法播放建议您观看其它内容。'

          let p = document.createElement('p')
          p.style.position = 'absolute'
          p.style.top = '0'
          p.style.left = '50%'
          p.style.transform = 'translateX(-50%)'
          p.style.color = '#fff'
          p.style.zIndex = '9999'
          //用innerHTML方法直接给P标签赋值
          p.innerHTML =
            '啊哦，播放出错了。<br>请刷新重试，如无法播放建议您观看其它内容。'
          that.$refs.videoBox.appendChild(p)
        })

        that.$nextTick(() => {
          // console.log('ref.myVideo', that.$refs.myVideo)
        })
      })

      this.myVideo = myVideo
    },
    play() {
      this.myVideo.play()
    },
    stop() {
      this.myVideo.stop()
    },
    reload() {
      this.myVideo.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.viewer {
  width: 100%;
  height: 100%;
  max-width: none;
}
/deep/ .vjs-big-play-button {
  display: none !important;
}
/deep/ .image360_loading::before {
  background-image: none !important;
}
/deep/ .panoviewer-control {
  .entervr {
    position: absolute;
    left: -1000px;
    top: -1000px;
  }
  .enterfs {
    position: absolute;
    left: -1000px;
    top: -1000px;
  }
}
/deep/ .image360_loadingBar {
  display: none;
}
</style>
